/**
 * Error to be thrown in API endpoint handler to return response with status code.
 * Works with middleware withErrorHandler, withSentryErrorHandler.
 */
export class ApiError extends Error {
  constructor(
    readonly code: number,
    message: string,
  ) {
    super(message);
  }
}
